export const INSTAGRAM_URL =
  "https://www.instagram.com/miyakoisland_premiumtrip/";
export const TIKTOK_URL = "https://www.tiktok.com/@ren.world_tour";
export const LINE_URL = "https://lin.ee/yFgNdA8";
